<template>
  <div class="key-container">
    <div class="radius"></div>
    <div class="titles" @click="showKeyboard = false">
      <div class="tit_right">
        <img :src="headImg" class="images" />
      </div>
      <div class="tit_le">
        付款给{{ `"${shopInfo.name || "店铺"}"` }}
        <!-- <p class="tit_btm">{{ companyName }}</p> -->
      </div>
    </div>
    <p class="text_money">金额</p>
    <div class="input-box" @click="showKeyboard = !showKeyboard">
      <span class="money_logo">￥</span
      ><span class="money_number">{{ money }}</span>
      <span class="lines" v-show="showLine && showKeyboard"></span>
    </div>
    <div class="keyboard" @click.stop="_handleKeyPress" v-if="showKeyboard">
      <div class="key-row">
        <div class="key-cell" data-num="1">1</div>
        <div class="key-cell" data-num="2">2</div>
        <div class="key-cell" data-num="3">3</div>
        <div class="key-cell" data-num="D">
          <img src="/static/image/deletes.png" data-num="D" class="deleteImg" />
        </div>
      </div>
      <div class="key-row">
        <div class="key-cell" data-num="4">4</div>
        <div class="key-cell" data-num="5">5</div>
        <div class="key-cell" data-num="6">6</div>
        <div class="key-cell" data-num="C">清空</div>
      </div>
      <div class="key-row">
        <div class="key-cell" data-num="7">7</div>
        <div class="key-cell" data-num="8">8</div>
        <div class="key-cell" data-num="9">9</div>
        <div class="key-cell" data-num="-1"></div>
      </div>

      <div class="key-row">
        <!-- <div class="key-cell disabled" data-num="-1"></div> -->
        <div class="key-cell key-zero" data-num="0" style="width:46%">0</div>
        <div class="key-cell" data-num=".">.</div>

        <div class="key-cell" data-num="-1"></div>
      </div>
      <div
        class="key-confirm"
        :class="money > 0 ? '' : 'disabledPay'"
        data-num="S"
      >
        付款
      </div>
    </div>
    <loading v-if="load"></loading>
    <!-- 会员信息 -->
    <!-- -->
    <div class="vip_content" v-if="!!isVIP && types === 'wechat'">
      <p class="payType_text">
        支付方式：会员卡(余额：{{ toFix(tateData.Money) }})
        <span class="changeType" @click="show = !show">更换</span>
      </p>
      <p class="vip_tit">----{{ shopInfo.vipTitle }}----</p>

      <p class="vip_detail" v-for="item in shopInfo.vipContent" :key="item._id">
        {{ item }}
      </p>
      <p class="vip_href" @click="toRecharge">立即进入</p>
    </div>
    <!-- 非会员展示 -->
    <!-- tessssssssssss -->
    <div class="vip_content notvip_content" v-if="!isVIP && types === 'wechat'">
      <p class="vip_tit">----{{ shopInfo.notVipTitle }}----</p>
      <p
        class="vip_detail"
        v-for="item in shopInfo.notVipContent"
        :key="item._id"
      >
        {{ item }}
      </p>
      <p class="vip_href" @click="handleToRegister">立即加入</p>
    </div>
    <!-- ceshi -->
    <!-- 弹窗 -->
    <div class="mask" v-if="show" @click="show = !show"></div>
    <div :class="!!show ? 'modal' : 'hidemodal'">
      <span class="closeBtn" @click="show = !show">+</span>
      <div class="check_tit">
        选择支付方式
      </div>
      <div class="check_card" @click="changePayType('card')">
        <div class="pay_card">会员卡支付</div>
        <img
          :src="
            payType == 'card' ? 'static/image/yes.png' : 'static/image/no.png'
          "
        />
      </div>
      <div class="check_card" @click="changePayType('weixin')">
        <div class="pay_card payWeixin">微信支付</div>
        <img
          :src="
            payType == 'weixin' ? 'static/image/yes.png' : 'static/image/no.png'
          "
        />
      </div>
      <div class="pay_button" @click="_handleConfirmKey">
        支付
      </div>
    </div>
  </div>
</template>

<script>
// import VConsole from "vconsole";
import { Toast, Indicator } from "mint-ui";
export default {
  data() {
    return {
      load: false,
      money: "",
      shopName: "太原街店",
      companyName: "睿商生鲜",
      headImg: "/static/image/store.png",
      showLine: false,
      appcode: "",
      code: "",
      companyID: "",
      payclient: "",
      types: "",
      auth_code: "",
      show: false,
      payType: "card",
      isVIP: false,
      tateData: {},
      showKeyboard: false,
      shopInfo: {}
    };
  },
  mounted() {
    // const vConsole = new VConsole();
    setInterval(() => {
      this.showLine = !this.showLine;
    }, 500);
    const {
      code,
      stat,
      companyID,
      serviceProviderTerminalID,
      paymentTerminalID,
      companyName,
      browserType, //browserType=wechat
      auth_code //支付宝
    } = this.$route.query;
    // 存储localstorge
    localStorage.setItem("appcode", stat);
    localStorage.setItem("code", code);
    localStorage.setItem("companyID", companyID);

    this.code = code;
    this.auth_code = auth_code;
    this.types = browserType;
    this.appcode = stat;
    this.companyID = companyID;
    this.payclient = paymentTerminalID;
    this.companyName = companyName;
    console.log(this.$route.query, "query---------------");
    let url = window.location.href.split("#")[0];
    url = encodeURIComponent(url);
    // 获取用户商户信息
    this.getShopInfo();
    this.getUserInfo();

    if (browserType === "wechat") {
      this.Request(
        "api/v1/wechat/jsapi/signature",
        { url, terminalID: serviceProviderTerminalID },
        r => {
          if (r.data.code == "20000") {
            const { data } = r;
            wx.config({
              debug: false, // 开启调试模式, 调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.data.appid, // 必填，公众号的唯一标识
              timestamp: data.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
              signature: data.data.signature, // 必填，签名
              jsApiList: ["chooseWXPay"]
            });
          } else {
            alert(r.data.msg);
          }
        },
        err => {
          alert(err);
        }
      );
    }
  },
  methods: {
    toFix(num) {
      return Number(num).toFixed(2);
    },
    getShopInfo() {
      this.RequestVIP(
        `h5/vip/company/info`,
        res => {
          if (res.data.code === "20000") {
            console.log(res);
            this.shopInfo = res.data.data;
          }
        },
        err => console.log(err)
      );
    },
    // 获取会员信息
    getUserInfo() {
      this.RequestVIP(
        `h5/vip/info?openID=${this.code}&CompanyID=${this.companyID}`,
        res => {
          // console.log(res, "resssssssssss");
          if (res.data.code === "50000") {
            this.tateData = [];
            this.isVIP = false;
            return;
          } else {
            if (!!res.data.data.table1 && !!res.data.data.table1.length) {
              localStorage.setItem("VIPNO", res.data.data.table1[0].VIPNO);
              localStorage.setItem(
                "Integral",
                res.data.data.table1[0].Integral
              );
              localStorage.setItem("Money", res.data.data.table1[0].Money);
              localStorage.setItem(
                "payclient",
                res.data.data.table1[0].payclient
              );

              this.tateData = res.data.data.table1[0];
              this.isVIP = true;
            }
          }
        },
        err => console.log(err)
      );
      this.RequestMall("GET", "h5/mall/shop/all", {}, r => {
        localStorage.setItem("shopID", r.data.data.result[0].id);
        localStorage.setItem("shopList", JSON.stringify(r.data.data.result));
      });
    },
    //处理按键
    _handleKeyPress(e) {
      console.log(
        window.AlipayJSBridge,
        "window.AlipayJSBridgewindow.AlipayJSBridge"
      );
      let num = e.target.dataset.num;
      //不同按键处理逻辑
      // -1 代表无效按键，直接返回
      if (num == -1) return false;
      switch (String(num)) {
        //小数点
        case ".":
          this._handleDecimalPoint();
          break;
        //删除键
        case "D":
          this._handleDeleteKey();
          break;
        //清空键
        case "C":
          this._handleClearKey();
          break;
        //确认键
        case "S":
          if (this.types === "wechat") {
            this.show = true;
          } else {
            this._handleConfirmKey();
          }

          break;
        default:
          this._handleNumberKey(num);
          break;
      }
    },
    //处理小数点函数
    _handleDecimalPoint() {
      //如果包含小数点，直接返回
      if (this.money.indexOf(".") > -1) return false;
      //如果小数点是第一位，补0
      if (!this.money.length) this.money = "0.";
      //如果不是，添加一个小数点
      else this.money = this.money + ".";
    },
    //处理删除键
    _handleDeleteKey() {
      let S = this.money;
      //如果没有输入，直接返回
      if (!S.length) return false;
      //否则删除最后一个
      this.money = S.substring(0, S.length - 1);
    },
    //处理清空键
    _handleClearKey() {
      this.money = "";
    },
    //处理数字
    _handleNumberKey(num) {
      if (this.money.length > 7) return;

      if (!num) return;
      let S = this.money;

      if (S.indexOf(".") > -1 && S.substring(S.indexOf(".") + 1).length < 2)
        this.money = S + num;
      if (!(S.indexOf(".") > -1)) {
        //如果第一位是0，只能输入小数点
        if (num == 0 && S.length == 0) this.money = "0.";
        else {
          if (S.length && Number(S.charAt(0)) === 0) return;
          this.money = S + num;
        }
      }
    },
    //提交
    _handleConfirmKey() {
      this.load = true;
      let S = this.money;
      //未输入
      if (!S.length) {
        alert("您目前未输入!");
        this.load = false;
        return false;
      }
      //将 8. 这种转换成 8.00
      if (S.indexOf(".") > -1 && S.indexOf(".") == S.length - 1)
        S = Number(S.substring(0, S.length - 1)).toFixed(2);
      //保留两位
      S = Number(S).toFixed(2);
      if (S == 0) {
        //   金额是0
        return;
      }
      console.log(S, this.types, "ssssss");
      if (this.types === "wechat") {
        const dataStr = new Date().getTime();
        const shopID = localStorage.getItem("shopID");
        if (this.payType === "weixin") {
          this.RequestMall(
            "POST",
            `h5/mall/order?shopID=${shopID}&openID=${this.code}&saleTempID=${dataStr}`,
            {
              companyID: this.companyID,
              shopID: shopID,
              saleTempID: this.dataStr,
              openID: this.code,
              amount: Number(S),
              type: 2
            },
            res => {
              const orderID = res.data.data.orderID;
              this.Request1(
                "v1/payment/prepay",
                {
                  providerName: "dejipay",
                  payType: "wechat",
                  clientType: "h5pay",
                  terminalID: this.payclient,
                  notifyURL: "https://api.cnuri.cn/payment-pre/ping",
                  body: "{h5pay:jsapi}",
                  total_fee: Number(S) * 100,
                  out_trade_no: orderID,
                  openID: this.code
                },
                r => {
                  this.load = false;
                  const { data } = r;
                  let that = this;
                  // 失败逻辑
                  if (data.code !== 0)
                    return alert(data.msg ? data.msg : "请求支付失败");
                  const { data: orderInfo } = data;
                  // 成功逻辑
                  const prepayResult = JSON.parse(orderInfo.raw);
                  const { code, data: raw, msg } = prepayResult;
                  if (code !== "20000") return alert(msg);
                  wx.ready(function() {
                    wx.chooseWXPay({
                      timestamp: raw.timestamp,
                      nonceStr: raw.nonceStr,
                      package: `prepay_id=${raw.prepay_id}`,
                      signType: raw.signType,
                      paySign: raw.paySign,
                      success: function(res) {
                        alert("支付成功！");
                        // // that.load = false;
                        // window.location.href = "/#/Recharge";
                      },
                      cancel: function(res) {
                        alert("已取消支付");
                      },
                      fail: function(res) {}
                    });
                  });
                },
                err => {
                  this.load = false;
                  console.log(err);
                }
              );
            }
          );
        } else {
          // 余额支付
          // const shopID = localStorage.getItem("shopID");
          // 创建订单
          this.RequestMall(
            "POST",
            `h5/mall/order?shopID=${shopID}&openID=${this.code}&saleTempID=${dataStr}`,
            {
              companyID: this.companyID,
              shopID: shopID,
              saleTempID: this.dataStr,
              openID: this.code,
              amount: Number(S),
              type: 2
            },
            res => {
              console.log(res);
              const orderID = res.data.data.orderID;
              const appCode = localStorage.getItem("appcode");
              const cardNo = localStorage.getItem("VIPNO");
              // 余额支付
              this.RequestMall(
                "POST",
                "h5/mall/order/balancepay",
                {
                  amount: Number(S),
                  cardNo: cardNo,
                  appCode: appCode,
                  orderID
                },
                r => {
                  this.load = false;
                  // 跳转支付成功页面
                  if (r.data.code === "20000") {
                    window.location.href = `/#/PaySuccess?shop=${
                      this.shopInfo.name
                    }&money=${Number(S)}`;
                  } else {
                    window.location.href = `/#/PayError?shop=${this.shopInfo.name}`;
                  }
                },
                err => console.log(err)
              );
            },
            err => console.log(err)
          );
        }
      } else {
        console.log(this.auth_code, " this.auth_code this.auth_code");
        // 支付宝
        this.load = false;
        this.Request1(
          "v1/payment/prepay",
          {
            providerName: "dejipay",
            payType: "alipay",
            clientType: "mediapress",
            terminalID: this.payclient,
            body: "iphone 12",
            total_fee: Number(S) * 100,
            auth_code: this.auth_code
          },
          // {
          //   providerName: "dejipay",
          //   payType: "alipay",
          //   clientType: "mediapress",
          //   terminalID: this.payclient,
          //   body: "iphone 12",
          //   out_trade_no: "ot0010-104",
          //   total_fee: Number(S) * 100,
          //   auth_code: this.auth_code
          // },
          r => {
            const tradeNo = JSON.parse(r.data.data.raw).tradeNo;
            console.log(tradeNo, "tradeNotradeNotradeNotradeNotradeNo");
            window.AlipayJSBridge.call(
              "tradePay",
              {
                tradeNO: tradeNo
              },
              function(result) {
                console.log(result, "=====resultttttttttt");
              }
            );
          }
        );
      }
    },
    // 跳转充值
    toRecharge() {
      window.location.href = "/#/Recharge";
    },
    // 跳转注册
    handleToRegister() {
      window.location.href = `/#/RegisterByCode?shopInfo=${JSON.stringify({
        name: this.shopInfo.name,
        content: {
          title: this.shopInfo.notVipTitle,
          content: this.shopInfo.notVipContent
        }
      })}`;
    },
    changePayType(val) {
      this.payType = val;
    }
  }
};
</script>

<style scoped>
.key-container {
  background: white;
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.input-box {
  color: #212121;
  font-size: 22px;
  font-weight: bold;
  height: 40px;
  border-bottom: 1px solid rgba(238, 238, 238, 0.39);
  padding: 0 5px;
  text-align: left;
  width: 90%;
  position: fixed;
  top: 97px;
  box-sizing: border-box;
}
.money_logo {
  font-size: 22px;
}
.money_number {
  font-size: 33px;
}
.keyboard {
  position: fixed;
  bottom: 0;
  left: 0;
  background: #f5f5f5;
  padding: 5px 0;
  /* height: 240px; */
  z-index: 9999;
  width: 100%;
}
.titles {
  width: 100%;
  height: 72px;
  background: #f5f5f5;
  /* display: flex;
  justify-content: space-between; */
  padding: 0 8%;
  box-sizing: border-box;
}
.tit_le {
  width: 100%;
  text-align: center;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 22px;
  color: #212121;
  opacity: 1;
}

.tit_right {
  width: 100%;
  /* height: 40px; */
  margin-top: 11px;
  text-align: center;
  /* background: white; */
}
.images {
  width: 29px;
  /* height: 29px; */
}
.keyboard .key-row {
  display: flex;
  justify-content: space-around;
  position: relative;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
}

.keyboard .key-row::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  /* border-top: 1px solid #d5d5d6; */
  color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.keyboard .key-cell {
  width: 21%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  position: relative;
  border-radius: 5px;
  box-sizing: border-box;
  background: white;
  font-weight: 700;
}
.keyboard .key-cell:nth-last-child(1)::after {
  border-right: 0;
}

.keyboard .disabled {
  background: rgba(180, 216, 255, 0.39);
}

.keyboard .key-confirm {
  position: absolute;
  text-align: center;
  height: 112px;
  width: 24%;
  font-size: 12px;
  font-weight: 700;
  color: white;
  line-height: 118px;
  background: #fed101;
  border-radius: 5px;
  z-index: 5;
  right: 0;
  bottom: 1px;
}
.text_money {
  position: fixed;
  top: 86px;
  left: 20px;
  font-size: 10px;
  color: #757575;
}
.radius {
  width: 100%;
  height: 30px;
  position: fixed;
  top: 90px;
  background: white;
  border-radius: 50px;
}
.lines {
  display: inline-block;
  height: 20px;
  border-left: solid 1px #1890ff;
}
.keyboard .disabledPay {
  background: #fed101;
}
.deleteImg {
  width: 15px;
  height: 15px;
  margin-top: 8px;
}
.key-cell:active {
  background: rgb(233, 236, 236);
}
.vip_content {
  width: 100%;
  text-align: center;
  height: 100px;
  position: fixed;
  top: 148px;
  /* z-index: 999; */
  /* background: rgb(224, 220, 193); */
}
.notvip_content {
  top: 130px;
}
.vip_content p {
  text-align: center;
}
.payType_text {
  height: 10px;
  font-size: 10px;
  font-weight: 400;
  line-height: 17px;
  color: #212121;
  opacity: 1;
  z-index: 9;
}
.changeType {
  display: inline-block;
  width: 33px;
  height: 17px;
  background: rgba(255, 255, 255, 0.39);
  border: 1px solid #ffa516;
  opacity: 1;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 400;
  line-height: 17px;
  color: #ffa516;
  text-align: center;
  margin-left: 5px;
  z-index: 9;
}
.vip_tit {
  font-size: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  font-weight: 400;
  line-height: 17px;
  color: #212121;
  opacity: 1;
}
.vip_detail {
  font-size: 10px;
  /* margin-top: 10px; */
  font-weight: 400;
  line-height: 17px;
  color: #212121;
  opacity: 1;
  margin-top: 2px;
}
.vip_href {
  font-size: 10px;
  margin-top: 8px;
  font-weight: 400;
  line-height: 17px;
  color: #ffa516;
  opacity: 1;
}
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.39);
  position: fixed;
  top: 0;
  left: 0;
}
.modal {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  /* background: coral; */
  height: 250px;
  background: #ffffff;
  z-index: 9999;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  transition: all 0.5s;
}
.hidemodal {
  width: 100%;
  position: fixed;
  bottom: -250px;
  left: 0;
  height: 250px;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  transition: all 0.5s;
}
.check_tit {
  width: 100%;
  height: 39px;
  line-height: 39px;
  background: #f5f5f5;
  font-size: 13px;
  line-height: 39px;
  color: #212121;
  text-align: center;
}
.closeBtn {
  font-size: 22px;
  font-weight: 500;
  position: absolute;
  top: 3px;
  right: 10px;
  transform: rotate(45deg);
}
.check_card {
  width: calc(100% - 50px);
  height: 50px;
  line-height: 55px;
  margin-left: 25px;
  border-bottom: solid 1px #eeeeee;
  display: flex;
  justify-content: space-between;
}

.check_card img {
  width: 16px;
  height: 16px;
  margin-top: 19px;
  vertical-align: middle;
}
.pay_card {
  font-size: 13px;
  font-weight: 400;
  color: #212121;
  background: url("/static/image/ka.png") 0px 20px no-repeat;
  background-size: 16px 12px;
  padding-left: 25px;
}
.payWeixin {
  background: url("/static/image/weixin.png") 0px 20px no-repeat;
}
.pay_button {
  width: calc(100% - 28px);
  position: absolute;
  bottom: 11px;
  left: 14px;
  height: 29px;
  background: #fed101;
  line-height: 29px;
  border-radius: 3px;
  font-size: 13px;
  color: #212121;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/shopPay/index.vue